//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";

const comparisonListInt = [
  { label: "Igual", value: "=" },
  { label: "Diferente", value: "!=" },
  { label: "Menor", value: "<" },
  { label: "Menor ou Igual", value: "<=" },
  { label: "Maior", value: ">" },
  { label: "Maior ou igual", value: ">=" },
  { label: "Vazio", value: "= null" },
  { label: "Não vazio", value: "!= null" },
];

const comparisonListHierarchies = [
  { label: "Igual", value: "in" },
  { label: "Diferente", value: "not in" },
];

export default {
  name: "Int",
  props: ["value", "rules", "selectedRule"],
  data: () => ({
    storedNumber: null,
    comparisonOperator: null,
    comparisonList: null,
    hierarchyMode: false,
    hierarchyList: null,
    loadingHiearchy: false,
  }),
  mounted() {
    let rule = null
    if (this.selectedRule) {
      rule = this.rules.find((r) => r.identifier === this.selectedRule);
    } else {
      rule = this.rules.find((r) => r.identifier === this.selectedRule);
    }
    if (rule.related_pg_table === "hierarchy_levels") {
      this.storedNumber = [];
      this.comparisonList = comparisonListHierarchies;
      this.hierarchyMode = true;
      this.getHierarchyOptions(rule.name);
    } else if (rule.name === "Data - Dia da Semana") {
      this.storedNumber = [];
      this.comparisonList = comparisonListHierarchies;
      this.hierarchyMode = true;
      this.hierarchyList = this.getWeekdayObject();
    } else {
      this.comparisonList = comparisonListInt;
      this.hierarchyMode = false;
    }

    if (this.value) {
      if (this.hierarchyMode) {
        const regex = /\(|\)|'/g;
        let valueList = this.value.value.replaceAll(regex, '').split(',');
        for (let i = 0; i < valueList.length; i++) {
          this.storedNumber.push(parseInt(valueList[i]));
        }
      } else {
        this.storedNumber = this.value.value;
      }
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  },
  methods: {
    async getHierarchyOptions(known_name) {
      this.loadingHiearchy = true;
      let result = await BackendServices.getHierarchiesDataBuilder(known_name);
      this.hierarchyList = result.data;
      this.loadingHiearchy = false;
    },
    updateValues: function () {
      if (
        this.comparisonOperator.value == "= null" ||
        this.comparisonOperator.value == "!= null"
      ) {
        this.$emit("input", {
          ...this.value,
          value: "",
          comparisonOperator: this.comparisonOperator.value,
        });
        this.storedNumber = 0.0;
      } else {
        this.$emit("input", {
          ...this.value,
          value: this.storedNumber,
          comparisonOperator: this.comparisonOperator.value,
        });
      }
    },
    arrayToString: function (array) {
      let result = "";
      if (array.length > 0) {
        result = "(";
        result += array.join(",")
        result += ")";
      }
      return result;
    },
    getWeekdayObject: function () {
      return [{ id: 1, name: "Domingo" }, { id: 2, name: "Segunda-Feira" }, { id: 3, name: "Terça-Feira" }, { id: 4, name: "Quarta-Feira" }, { id: 5, name: "Quinta-Feira" }, { id: 6, name: "Sexta-Feira" }, { id: 7, name: "Sábado" }]
    },
  },
  computed: {
    number: {
      get() {
        return this.storedNumber;
      },
      set(value) {
        if (Array.isArray(value)) {
          this.$emit("input", {
            ...this.value,
            value: this.arrayToString(value),
            comparisonOperator: this.comparisonOperator.value,
          });
        } else {
          this.$emit("input", {
            ...this.value,
            value: value,
            comparisonOperator: this.comparisonOperator.value,
          });
        }
        this.storedNumber = value;
      },
    },
    //Disables the value input if no operator is chosen or the null operators are selected
    hasSelectedOperator: {
      get() {
        return (
          this.comparisonOperator == null ||
          this.comparisonOperator.value == "= null" ||
          this.comparisonOperator.value == "!= null"
        );
      },
    },
  },
  watch: {
    selectedRule: function () {
      let reloadedValue = Number.parseInt(this.value.value)
      if (Number.isNaN(reloadedValue)) {
        const regex = /\(|\)|'/g;
        let valueList = this.value.value.replaceAll(regex, '').split(',');
        for (let i = 0; i < valueList.length; i++) {
          this.storedNumber.push(parseInt(valueList[i]));
        }
        this.hierarchyMode = true
      } else {
        this.storedNumber = reloadedValue;
        this.hierarchyMode = false
      }
    },
    value: {
      deep: true,
      handler: function () {
        let rule = null
        if (this.selectedRule) {
          rule = this.rules.find((r) => r.identifier === this.selectedRule);
        } else {
          rule = this.rules.find((r) => r.identifier === this.selectedRule);
        }
        if (rule.related_pg_table === "hierarchy_levels") {
          this.storedNumber = [];
          this.comparisonList = comparisonListHierarchies;
          this.hierarchyMode = true;
          this.getHierarchyOptions(rule.name);
        } else if (rule.name === "Data - Dia da Semana") {
          this.storedNumber = [];
          this.comparisonList = comparisonListHierarchies;
          this.hierarchyMode = true;
          this.hierarchyList = this.getWeekdayObject();
        } else {
          this.comparisonList = comparisonListInt;
          this.hierarchyMode = false;
        }
        this.comparisonOperator = this.comparisonList.find(
          (e) => e.value === this.value.comparisonOperator
        );

        if (this.hierarchyMode) {
          const regex = /\(|\)|'/g;
          let valueList = this.value.value.replaceAll(regex, '').split(',');
          this.storedNumber = [];
          if (valueList.length === 1 && valueList[0] === '') {
            return;
          }
          for (let i = 0; i < valueList.length; i++) {
            this.storedNumber.push(parseInt(valueList[i]));
          }

        } else {
          this.storedNumber = this.value.value;
        }
      },
    },
  },
};
